var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"login-m-btn",on:{"click":_vm.handleMetamaskLogin}},[_c('MetamaskLogo'),_c('span',[_vm._v("Metamask")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }